<wiz-hgroup #actionContainer height="100%" verticalAlign="center" style="padding-left:5px" width="100%" [wizDisabled]="owner.wizDisabled">

  <wiz-checkbox [wizShowLabel]="false" [manageModel]=false  [wizChecked]="isSelected()"></wiz-checkbox>

  <wiz-image [sourceObservable]='data.iconOrDie' width='24px' height='24px'></wiz-image>
  
  <wiz-label [wizLabel]='data.trsLabel'></wiz-label>

</wiz-hgroup>
